import React,{Component} from "react";
import Head from 'next/head'
import Wrapper from '../components/Wrapper';

class Contact extends Component{

    constructor()
    {
        super();
        this.state = {
            name:"",
            email:"",
            text:"",
            submitted:false
        }
    }


    onSubmit = ()=>
    {
        const {name,email,text}  = this.state;
        fetch('/api/contact', {
            method: 'post',
            headers: {
                'Accept': 'application/json, text/plain, */*',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({name,email,text})
        }).then((res) => {
            res.status === 200 ? this.setState({ submitted: true }) : ''
        })
    };
    handleChange = (fieldName)=>
    {
        return (event) =>{
            this.setState({[fieldName]: event.target.value});
        };
    };

    render()
    {
        return <Wrapper>
            <div id="extra">
                {!this.state.submitted && <div className="container">
                    <header>
                        <h2>Get in touch</h2>
                    </header>
                     <form onSubmit={(e)=>
                    {
                        e.preventDefault();
                        this.onSubmit();
                    }
                    }>
                        <fieldset>
                            <input onChange={this.handleChange("name")} value={this.state.name}
                                   required type="text" placeholder="Your name"/>
                            <input onChange={this.handleChange("email")} value={this.state.email}
                                   required type="email" placeholder="Your E-mail"/>
                            <textarea onChange={this.handleChange("text")} value={this.state.text}
                                      required placeholder="Your text" cols="150" rows="5" />
                            <button type="submit" className="button">Send</button>
                        </fieldset>
                    </form>

                </div>}
                {this.state.submitted &&
                <div className="container">
                    <header>
                        <h2>Thanks for contacting us! We'll get back to you shortly!</h2>
                    </header>

                </div>}

            </div>
        </Wrapper>
    }
}

export default Contact;